import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "@material-ui/core";

class MusicButton extends Component {

    render()
    {
        return (
            <Button disableRipple={true} onClick={this.props.musicToggleFunc} style={{backgroundColor: "transparent"}}><img
                style={{
                height: this.props.imageSize,
                justifySelf: "center",
                filter: this.props.musicState
                    ? ""
                    : "grayscale(50%)",
                opacity: this.props.musicState
                    ? 1
                    : 0.5
            }}
                alt="Music Toggle"
                src={this.props.musicState ? this.props.musicToggleOnImage : this.props.musicToggleOffImage}/></Button>
        );
    }
}

MusicButton.propTypes = {
    musicToggleOnImage: PropTypes.string,
    musicToggleOffImage: PropTypes.string,
    musicToggleFunc: PropTypes.func,
    musicState: PropTypes.bool,
    imageSize: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
};

MusicButton.defaultProps = {
    musicToggleOnImage: "",
    musicToggleOffImage: "",
    musicToggleFunc: function () {
        console.log("Pressed music toggle");
    },
    musicState: true,
    imageSize: "10vh"
};

export default MusicButton;